import { useEffect, useRef, useState } from "react";

const SRC = "/media/earth.mp4";
const SRC_MOBILE = "/media/earth-mobile.mp4";
const POSTER = "/media/earth-poster.webp";

/**
 * The hero's looping footage: the earth from orbit. Self-hosted, starts from its poster and
 * fades in once playable; the smaller file on narrow screens; poster only for reduced motion.
 */
export default function HeroVideo({ className = "" }: { className?: string }) {
  const ref = useRef<HTMLVideoElement>(null);
  const [src, setSrc] = useState<string>();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    setSrc(window.matchMedia("(max-width: 767px)").matches ? SRC_MOBILE : SRC);
  }, []);

  useEffect(() => {
    const video = ref.current;
    if (!video || !src) return;
    video.play().catch(() => {
      /* autoplay refused (e.g. data saver): the poster stays */
    });
  }, [src]);

  return (
    <div className={`hero-video ${ready ? "is-ready" : ""} ${className}`} aria-hidden="true">
      <img src={POSTER} alt="" className="hero-video__media" decoding="async" />
      {src && (
        <video
          ref={ref}
          src={src}
          className="hero-video__media hero-video__clip"
          muted
          loop
          playsInline
          autoPlay
          preload="auto"
          onLoadedData={() => setReady(true)}
        />
      )}
    </div>
  );
}
